import BotCard from '@components/ContactUsV2/BotCard/BotCard'
import styles from './BotChannel.module.scss'

const BotChannel = ({ isMobile, triggerCopilot, ...props }) => {
  const { BotCard: data, subtitles, title } = props?.bot_channel?.data?.attributes

  return (
    <div className={isMobile ? styles.mobile : styles.desktop}>
      <div className={styles.botChannelContainer}>
        <div className={styles.title}>{title}</div>
        {!!subtitles?.length && (
          <div className={styles.subtitles}>
            {subtitles.map((subtitle, index) => (
              <span key={index}>{subtitle}</span>
            ))}
          </div>
        )}
        <BotCard {...data} isMobile={isMobile} triggerCopilot={triggerCopilot} />
      </div>
    </div>
  )
}

export default BotChannel
